import React from 'react';
import { Box, SxProps } from '@mui/material';
import SearchBarList from './SearchBarList';
import { IUserPaginationResponse } from '../../../interfaces/user.interface';

type MobileSearchModalProps = {
  search: string;
  isOpen: boolean;
  isLoading: boolean;
  users?: IUserPaginationResponse;
  onClose: () => void;
  sx?: SxProps;
};

const MobileSearchModal = ({
  search,
  isOpen,
  isLoading,
  users,
  onClose,
  sx,
}: MobileSearchModalProps) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 66,
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        borderTop: '1px solid #E0E0E0',
        ...sx,
      }}
    >
      <SearchBarList
        search={search}
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isLoading}
        users={users}
      />
    </Box>
  );
};

export default MobileSearchModal;
